import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TagIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Tag",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.93 1.97h-9.38c-.85 0-1.62.35-2.17.91S2.9 15.39 2.9 15.39c-.56.56-.9 1.33-.9 2.18s.34 1.62.9 2.18l9.37 9.37c.56.56 1.33.9 2.18.9s1.62-.34 2.18-.9L29.08 16.6c.56-.55.91-1.32.91-2.17V5.06c0-1.71-1.38-3.09-3.07-3.09Zm-4.92 10.02a2 2 0 1 1 2-2 2.01 2.01 0 0 1-2 1.95V12Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.28 31.86c-1.06 0-2.05-.41-2.79-1.16L1.01 19.23c-.75-.75-1.16-1.74-1.16-2.79s.41-2.05 1.16-2.79L13.65 1.01a3.92 3.92 0 0 1 2.79-1.16h11.47c2.18 0 3.95 1.77 3.95 3.95v11.47c0 1.04-.42 2.06-1.16 2.79L18.07 30.69a3.92 3.92 0 0 1-2.79 1.16Zm1.16-29.72c-.44 0-.86.17-1.18.49L2.63 15.26c-.31.31-.49.73-.49 1.18s.17.86.49 1.18L14.1 29.09c.63.63 1.72.63 2.35 0l12.63-12.63c.31-.31.49-.74.49-1.18V3.81c0-.44-.17-.86-.49-1.18s-.73-.49-1.18-.49H16.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 14.71c-2.52 0-4.57-2.05-4.57-4.57s2.05-4.57 4.57-4.57 4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.85c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29"
      })]
    })
  }));
};